import { render, staticRenderFns } from "./I2JsonEditor.vue?vue&type=template&id=3fbf9f0b&scoped=true"
import script from "./I2JsonEditor.vue?vue&type=script&lang=js"
export * from "./I2JsonEditor.vue?vue&type=script&lang=js"
import style0 from "./I2JsonEditor.vue?vue&type=style&index=0&id=3fbf9f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf9f0b",
  null
  
)

export default component.exports